import { useState } from 'react';
import ListColumn from 'src/componentes/NewList/ListColumn';
import { useIntl } from 'react-intl';
import useAuth from 'src/hooks/useAuth';
import { capitalizeFirstLetter } from 'src/utils/string';
import ContentManager from 'src/componentes/content-manager';
import DicionarioRiscoEdit from './edit';
import ValidacaoRestricao from 'src/paginas/item/validacao-restricao';
import NewListTree from 'src/componentes/NewList/NewListTree';
import { ErrorBoundary } from 'react-error-boundary';
import StatusBadge from 'src/componentes/StatusBadge';
import { STATUS_BADGE } from 'src/utils/constants';

const MAX_NIVEL = 3;
function DicionarioRiscoView({
  columnsTag,
  filterTag,
  entityTag,
  defaultSort,
  defaultSortBy,
  parameters = {},
  endpoint,
  controleId,
  disabled,
  select = false,
  afterSave,
  calcularProbabilidadeGeralPorTipo,
  ...rest
}) {
  const intl = useIntl();
  const { terms: resources } = useAuth();
  const [saved, setSaved] = useState(1);

  const handleRefresh = () => {
    setSaved(saved + 1);
  };

  const handleDeleteClick = (item) => {
    ContentManager.addContent(
      <ValidacaoRestricao
        url="/DicionarioRisco/ValidarRestricoes"
        urlExclusao="/DicionarioRisco/AtualizarStatusExcluido"
        afterRemove={handleRefresh}
        item={item}
        isEdit={true}
        paginar
      />
    );
  };

  const handleNew = (onRefresh, refreshData) =>
    ContentManager.addContent(
      <DicionarioRiscoEdit
        endpoint={endpoint}
        parameters={{ controleId: controleId }}
        //handleClose={() => handleRefresh(refreshData)}
        refreshData={refreshData}
      />
    );

  const handleEdit = (item, indexItem, parameters, onRefresh) => {
    ContentManager.addContent(
      <DicionarioRiscoEdit
        endpoint={endpoint}
        item={item}
        disabled={disabled}
        refreshData={onRefresh}
      />
    );
  };

  const renderNome = (item) => (
    <a
      tabIndex="-1"
      onClick={() => handleEdit(item, null, parameters, handleRefresh)}
      style={{ cursor: 'pointer' }}
    >
      {item.nome}
    </a>
  );

  const renderStatus = (item) => {
    if (item.status?.id == 1)
      return <StatusBadge type={STATUS_BADGE.Inativo} />;
    else return <StatusBadge type={STATUS_BADGE.Ativo} />;
  };

  const renderNivel = (item) => {
    return (
      <p>
        {item.nivel}/{MAX_NIVEL}
      </p>
    );
  };

  const defaultColumns = [
    <ListColumn key="tree" style={{ width: 1 }} minWidth={1} default tree />,
    <ListColumn
      key="idIntegracao"
      headerText={capitalizeFirstLetter(
        intl.formatMessage({ id: 'idIntegracao' })
      )}
      valueField="idIntegracao"
      default
      sortField="idIntegracao"
    />,
    <ListColumn
      key="nome"
      headerText={capitalizeFirstLetter(intl.formatMessage({ id: 'nome' }))}
      style={{ width: '30%' }}
      valueField="nome"
      valueFunction={(item) => renderNome(item)}
      default
      sortField="nome"
    />,
    <ListColumn
      key="descricao"
      headerText={capitalizeFirstLetter(
        intl.formatMessage({ id: 'descricao' })
      )}
      style={{ width: '35%' }}
      valueField="descricao"
      default
      sortField="descricao"
    />,
    <ListColumn
      key="nomePai"
      headerText={capitalizeFirstLetter(
        intl.formatMessage({ id: 'labelCategoriaSuperior' })
      )}
      valueField="nomePai"
      default
    />,
    <ListColumn
      key="status"
      headerText={capitalizeFirstLetter(intl.formatMessage({ id: 'status' }))}
      valueField="status"
      valueFunction={(item) => renderStatus(item)}
      default
    />,
    <ListColumn
      key="nivel"
      headerText={capitalizeFirstLetter(
        intl.formatMessage({ id: 'labelQuantidadeNiveis' })
      )}
      valueField="nivel"
      valueFunction={(item) => renderNivel(item)}
      tooltipHeader={intl.formatMessage(
        { id: 'labelQuantidadeNiveisInfo' },
        { risco: resources.risco }
      )}
      default
    />,
  ];


  function Fallback({ error, resetErrorBoundary }) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>Ops! Algo deu errado 🚨</h2>
        <pre>{error.message}</pre>
        <button onClick={resetErrorBoundary}>Tentar novamente</button>
      </div>
    );
  }

  const logError = (error, info) => {
    console.error('Erro capturado:', error, info);
  };

  return (
    <ErrorBoundary
      FallbackComponent={Fallback}
      onError={logError}
      onReset={() => {}}
    >
      <NewListTree
        endpoint={endpoint}
        defaultColumns={defaultColumns}
        sortField="Nome"
        onDeleting={handleDeleteClick}
        showNew
        showMenu
        handleNewClick={handleNew}
        handleEditClick={handleEdit}
        resources={resources}
        saved={saved}
        showCountPage={false}
        select={select}
        parameters={parameters}
        {...rest}
      />
    </ErrorBoundary>
  );
}

DicionarioRiscoView.defaultProps = {
  endpoint: '/DicionarioRisco',
  entityTag: null,
  defaultSort: 'nome',
  defaultSortBy: 'asc',
  selectedFilter: null,
  openLastFilter: false,
  parameters: {},
  showToolbar: true,
};

export default DicionarioRiscoView;
